import { gql } from '@apollo/client';

import { USER_AVATAR_DETAILS_FRAGMENT } from '../fragments/avatar';

export default gql`
  mutation updateMyAvatarMutation($data: UserUpdateInput!) {
    updateMe(data: $data) {
      ...BaseUserAvatar
    }
  }
  ${USER_AVATAR_DETAILS_FRAGMENT}
`;
